<main id="main">

    <kokos-header [page]="PagesEnum.SendMail" [title]="'sendmail.prepare.title' | i18next"></kokos-header>

    <div class="container-fluid ba-mailbox">


        <p class="ba-required-hint">{{ 'sendmail.fill-marked-fields' | i18next }}</p>

        <!--   Dienststellen-Auswahl  -->
        @if (hasMultipleDienststellen()) {
            <kokos-dienststellen-selector
                    [nachrichtenType]="nachrichtenType"
                    (nachrichtenTypeChanged)="onNachrichtenTypeChanged($event)">
            </kokos-dienststellen-selector>
        }

        <!--   Ansprechpartner anzeigen und ggf. Jobcenter auswählen  -->
        @if (!!dienststelle) {
            <kokos-ansprechpartner [dienststelle]="dienststelle"
                                   (jobcenterChanged)="onDienststelleChanged($event)"></kokos-ansprechpartner>
        }

        <!--   Anliegen und ggf. Subanliegen anzeigen  -->
        @if (showAnliegen) {
            <kokos-anliegen-selector
                    [anliegenList]="anliegenList"
                    [subanliegenList]="subanliegenList"
                    [anliegen]="anliegen"
                    [subanliegen]="subanliegen"
                    [showLoading]="loading"
                    (anliegenChanged)="onAnliegenChanged($event)"
                    (subanliegenChanged)="onSubanliegenChanged($event)">
            </kokos-anliegen-selector>
        }

        <!--   Hinweise zu Problemen anzeigen -->
        <kokos-hinweise [dienststelle]="dienststelle" [subanliegen]="subanliegen"
                        [anliegenEmpty]="!anliegenList.length"></kokos-hinweise>


        <pf-footer [forwardButton]="isReadyToProceed()?forwardButtonConfig:null" [backButton]="backButtonConfig"
                   (forwardButtonClicked)="handleForwardClicked()"
                   (backButtonClicked)="handleBackClicked()"></pf-footer>

    </div>

</main>